import { createApi } from "@reduxjs/toolkit/query/react";
import {
  mapExporterResponse,
} from "@/redux/mappers/Export/CreateNewJob/generalMapper.js";
import { apiurl } from "@/Config/ApiConfig/ApiUrl";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
import { mapCustomerResponse } from "@/redux/mappers/Export/CreateNewJob/generalMapper";
import { mapCustomerAddressResponse } from "@/redux/mappers/Export/CreateNewJob/generalMapper";

export const exporterApi = createApi({
  reducerPath: "exporterApi",
  baseQuery,
  tagTypes: ["Exporter"],
  endpoints: (builder) => ({
    getExporters: builder.query({
      query: () => apiurl.ExportAddress,
      transformResponse: (response) => {
        return response?.data?.map(mapExporterResponse);
      },
      providesTags: ["Exporter"],
    }),
    createExporter: builder.mutation({
      query: (data) => ({
        url: apiurl.Create_Exporter,
        method: "POST",
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        },
        body: data,
      }),
      invalidatesTags: ["Exporter"],
    }),
    updateExporter: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `${apiurl.Update_Exporter}/${id}`, // append id in URL
        method: "PUT",
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        },
        body: data,
      }),
      invalidatesTags: ["Exporter"],
    }),
    getExporterBankDetails : builder.query({
       query: ({id}) => `customer/CustomeBankDealer/${id}`,
      transformResponse: (response) => {
        return response?.data;
      },
      providesTags: ["Exporter"],
    }),
    getCustomers : builder.query({
      query: () => `/customers`,
      transformResponse: (response) => {
        return response?.data?.data.map(mapCustomerResponse);
      },
      providesTags: ["Exporter"]
    }),
    getCustomersAddress : builder.query({
      query: ({id}) => `/customers/addresses/${id}`,
      transformResponse: (response) => {
        return mapCustomerAddressResponse(response?.data);
      },
      providesTags: ["Exporter"]
    })
  }),
});

export const { useGetExportersQuery, useCreateExporterMutation,useUpdateExporterMutation,useGetExporterBankDetailsQuery,useGetCustomersQuery,useLazyGetCustomersAddressQuery } = exporterApi;

